import { AlertTriangle, Calendar, DollarSign, FileText } from "lucide-react";
import React, { useState } from "react";




const ActionSummaryCard = ({leaveCount, overdueCount, dueSoonCount, tasksCount}) => {
  
  const awardStatus =
  [  
    {
      id: 1,
      title: "Leave Requests",
      icon: Calendar,
      count: leaveCount,
      color: "red-white",
      shortDesc: "Pending",
    },
    {
      id: 2,
      title: "Overdue",
      icon: AlertTriangle,
      count: overdueCount,
      color: "orange-white",
      shortDesc: "Invoices"

    },
    {
      id: 3,
      title: "Due Soon",
      icon: DollarSign,
      count: dueSoonCount,
      color: "amber-white",
      shortDesc: "Invoices"
    },
    {
      id: 4,
      title: "Tasks",
      icon: FileText,
      count: tasksCount,
      color: "purple-white",
      shortDesc: "Pending"
},
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {awardStatus.map((item) => {
        const Icon = item.icon;
        return(
          <div
            key={item.id}
            className={`px-3 py-2 pb-4 space-y-6 rounded-xl card-border-s ${item.color}`}
          >
            <div className="flex items-center justify-between">
              <p className="text-[12px] label-color mb-1">{item.title}</p>
              <Icon className="w-3.5 h-3.5 icon-color" />
            </div>
            <div>
              <p className="text-[24px] font-semibold icon-color">{item.count}</p>
              <p className="text-[10px] text-color">{item.shortDesc}</p>
            </div>
          </div>   
        );
      })}
    </div>
  );
};

export default ActionSummaryCard;
